export default {
    project_name: "Unifrete",
    welcome_to: "Bem-vindo(a) à"
}